import _ from 'lodash'
import { calculateExtraStatisticsFields } from './utils'

export default class TotalOverall {
  constructor(statistics) {
    this.statistics = statistics
  }

  calculate() {
    const stats = _.flatMap(this.statistics)

    const totalSpent = _.sumBy(stats, 'spent')
    const totalImpressions = _.sumBy(stats, 'impressions')
    const totalClicks = _.sumBy(stats, 'clicks')
    const totalCounterImpressions = _.sumBy(stats, 'counterImpressions')
    const totalGoals = _.sumBy(stats, 'goals')

    return [
      calculateExtraStatisticsFields({
        spent: totalSpent,
        impressions: totalImpressions,
        counterImpressions: totalCounterImpressions,
        clicks: totalClicks,
        goals: totalGoals
      })
    ]
  }
}
